import React, { Component } from 'react'
import PropTypes from 'prop-types'

import QuestStatus from './QuestStatus'

export default class QuestStatusSelectOption extends Component {
  constructor() {
    super()
    this.handleMouseDownBound = this.handleMouseDown.bind(this)
    this.handleMouseEnterBound = this.handleMouseEnter.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
  }

  render() {
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDownBound}
        onMouseEnter={this.handleMouseEnterBound}
        onMouseMove={this.handleMouseMoveBound}
        title={this.props.option.title}
      >
        <QuestStatus status={this.props.option.className} />
      </div>
    )
  }

  handleMouseDown(event) {
    event.preventDefault()
    event.stopPropagation()
    this.props.onSelect(this.props.option, event)
  }

  handleMouseEnter(event) {
    this.props.onFocus(this.props.option, event)
  }

  handleMouseMove(event) {
    if (this.props.isFocused) return
    this.props.onFocus(this.props.option, event)
  }
}

QuestStatusSelectOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/mini/QuestStatusSelectOption.js